import {
  getGeoPolygonLayerIds,
  getGeoPointMarkerLayerIds,
} from '@elements/Geolocation'

export const PERMIT_ZONES_ID = 'permit-zones'
export const PERMIT_MARKERS_ID = 'permit-markers'

export const permitZonesIds = getGeoPolygonLayerIds(PERMIT_ZONES_ID)
export const permitMarkersIds = getGeoPointMarkerLayerIds(PERMIT_MARKERS_ID)

export const permitMapLayerIds = [
  ...permitZonesIds.layers,
  ...permitMarkersIds.layers,
]

export const permitMapSourceIds = [
  permitZonesIds.source,
  permitMarkersIds.source,
]
